<template>
  <div class="main">
    <div class="bg_container">
      <div class="logo_wrap">
        <img class="logo_cont" src="../assets/imgCata/logo.png" />
      </div>
      <div class="content_wrap">
        <div class="content_cont">
          <div class="img_contain">
            <div class="im">
              <div class="img_banner">
                <img class="img" src="../assets/imgCata/pagelogo1.png" />
              </div>
            </div>
            <div class="im">
              <div class="img_banner">
                <img class="img" src="../assets/imgCata/pagelogo2.png" />
              </div>
            </div>
          </div>
          <div class="img_contain1">
            <div class="title" style="text-align: center;width:40%">Wenno 2022</div>
            <div class="title" style="text-align: right;">Animal planet 2022</div>
          </div>
          <div class="img_contain">
            <div class="download"
                @click="pdflink(1)">
              <img
                class="download_img"
                src="../assets/imgCata/download.png"
              />
            </div>
            <div class="download"
                @click="pdflink(2)">
              <img
                class="download_img"
                src="../assets/imgCata/download.png"
              />
            </div>
          </div>
          <div class="licensed roBold lh40 text_black">
            Licensed Property: Animal Planet Territory:
          </div>
          <div class="Asia fs-14 lh40 text_black">
            <span class="roBold ">Asia</span>(People's Republic of
            China, Hong Kong, Japan, Philippines, Malaysia, Indonesia, Thailand,
            south Korea, Taiwan Australia, New Zealand, Vietnam, Cambodia,
            Singapore, India, Bangladesh, Myanmar, Mongolia, Brunei)
          </div>
          <div class="fs-14 lh40 text_black">
            <span class="roBold ">Middle East</span> (U.A.E, Saudi
            Arabia, Jordan Lebanon, oman, Kuwait Qatar, bahrain, Pakistan)
          </div>
          <div class="Europe fs-14 lh40 text_black">
            <span class="roBold ">Europe</span> (United Kingdom,
            Romania, Ireland, Spain, Poland, Turkey, Belgium, Portugal Italy,
            Bulgaria, Netherlands, Austria, Hungary, Germany, Slovakia, Croatia,
            Monaco, Luxembourg, Switzerland, Denmark, Sweden, Greece, Cyprus,
            Ukraine, Estonia, Israel, Czech Republic, Iceland, Finland, Norway)
            Russia and France
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      address: "",
      person: "",
    };
  },
  methods: {
    pdflink(type) {
      console.log(type);
      if (type == 1) {
        console.log("11");
        const a = document.createElement("a");
        a.href =
          "https://wennoanimal.com/pdf/download?pdf=2022_Catalogue_Wenno_Internation_1.pdf";
        console.log("a.href=", a.href);
        a.click();
      } else {
        console.log("22");
        const a = document.createElement("a");
        a.href =
          "https://wennoanimal.com/pdf/download?pdf=2022_Catalogue_Internation_V1.pdf";
        console.log("a.href=", a.href);
        a.click();
      }
    },
  },
};
</script>
<style scoped>
.bg_container {
  width: 100%;
  /* height: 100vh; */
  background: url("../assets/imgCata/background.png");
  background-size: 100% auto;
  padding-bottom: 30px;
  background-repeat: repeat-y;
}
.content_wrap {
  /* background: url("../assets/imgCata/content.png") no-repeat;
  background-size: 100% 100%; */
  /* height: 80vh; */
  background: white;
  padding-bottom: 20px;
  width: 84%;
  margin: 0 auto;
  border-radius:20px;
  margin-top:20px;
  /* border: 1px solid olive; */
}
.content_cont {
  /* border: 1px solid red; */
  padding-top: 30px;
  width: 85%;
  margin: 0 auto;
  overflow: hidden;
    /* margin-bottom: 20px; */
}

.im {
  /* background: pink; */
  width: calc((100% - 38px) / 2);
}

.im:nth-child(2) {
  margin-left: 38px;
}
.download:nth-child(2) {
  margin-left: 38px;
}
.img_contain {
  width: 100%;
  display: flex;
  align-items: flex-start;
}

.img_contain1 {
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.img_banner {
  width: 100%;
}
.title {
  line-height: 30px;
  font-size: 14px;
  color: black;

  font-family: "RobotoBold";
  /* border: 1px solid red; */
  width: 50%;
}

.title:nth-child(2) {
  float: right;
  /* background: pink; */
}
.roBold {
  font-family: "RobotoBold";
}

.licensed {
  margin-bottom: 10px;
}
.download {
  /* border: 1px solid red; */
  width: 100%;
  padding-top: 4px;
  margin-bottom: 12px;
}

.fs-14 {
  font-size: 14px;
}
.download_img {
  width: 100%;
  object-fit: cover;
}

.img {
  width: 100%;
}
.logo_wrap {
  /* border: 1px solid red; */

  width: 30%;
  margin-left: 9%;
  padding-top: 5vh;
}
.logo_cont {
  width: 100%;
  object-fit: cover;
  /* border: 1px solid green; */
}
input {
  outline: none;
  font-size: 18px;
}
.lh40 {
  line-height: 16px;
}

.text_black {
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/DownLoadpdf.vue